
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useGame } from '../contexts/GameContext';
import { gameRoles } from '../data/roles';
import { Badge } from '@/components/ui/badge';
import { Difficulty } from '@/components/ui/difficulty';

const RoleSelection: React.FC = () => {
  const { startGame } = useGame();
  
  return (
    <div className="container mx-auto py-10 px-4">
      <h2 className="text-2xl font-bold mb-6 text-center text-web3-green">Select Your Starting Role</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {gameRoles.map((role) => (
          <Card key={role.id} className="card-hover border-2 hover:border-web3-blue bg-web3-blue/10 border-web3-blue/20">
            <CardHeader>
              <div className="flex justify-between items-start">
                <CardTitle className="text-web3-green">{role.title}</CardTitle>
                <Difficulty level={role.difficulty || 'Medium'} />
              </div>
              <CardDescription className="text-white/80">{role.description}</CardDescription>
            </CardHeader>
            
            <CardContent className="pt-6">
              <div className="mb-4">
                <h3 className="text-sm font-medium text-white mb-2">Starting Skills:</h3>
                <div className="space-y-1">
                  {role.startingSkills.map((skill) => (
                    <div key={skill.id} className="flex items-center">
                      <div className="w-2 h-2 rounded-full bg-web3-green mr-2"></div>
                      <span className="text-white">{skill.name}</span>
                      <Badge variant="outline" className="ml-2 text-xs">{skill.category}</Badge>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="mb-4">
                <h3 className="text-sm font-medium text-white mb-2">Career Objective:</h3>
                <p className="text-sm text-white/80">{role.careerObjectives[0].description}</p>
              </div>
              
              <div>
                <h3 className="text-sm font-medium text-white mb-2">Strengths:</h3>
                <div className="text-sm text-white/80">
                  {role.strengths && role.strengths.map((strength, index) => (
                    <div key={index} className="flex items-center mb-1">
                      <div className="w-2 h-2 rounded-full bg-web3-green mr-2"></div>
                      <span>{strength}</span>
                    </div>
                  ))}
                  {!role.strengths && (
                    <p>Balanced career path with good advancement opportunities.</p>
                  )}
                </div>
              </div>
            </CardContent>
            
            <CardFooter>
              <Button 
                className="w-full"
                onClick={() => startGame(role)}
              >
                Start as {role.title.split(' ').slice(-1)[0]}
              </Button>
            </CardFooter>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RoleSelection;
